module.exports = __webpack_public_path__ + "static/image/sd_logo.eab994684492db94c8f22d89ff816fb6.png";